import React, { useState, useEffect } from "react";
import { Input, Image } from "antd";
import columns from "../../../columns/ib/Promotion.js";
import TableWithSkeleton from "../../../components/table/TableWithSkeleton.jsx";
import Pagination from "../../../components/pagination/Pagination.jsx";
import { GetAllPromotionByIdApi } from "../../../api/request/ib/ibpromotion.js";
import moment from "moment/moment.js";
import Eye from '../../../assets/Eye.jsx';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Copy from "../../../components/copy/Copy.jsx";


export default function Kyc() {
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [searchText, setSearchText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const { userDetails } = useSelector(state => state.user);

  const getAllpromotion = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        FilterText: "Active"
      }
      setIsLoading(true);
      const { data } = await GetAllPromotionByIdApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {

            return {
              ...item,
              url: (<div className="h-[50px] w-[50px] overflow-hidden">
                <Image src={item?.url} fallback='/assets/images/promotion-placeholder.png' className="object-cover w-full h-full" alt="img" />
              </div>),
              // actions: (<div className='cursor-pointer ' onClick={() => copyIframe(item)} ><Eye /></div>),
              actions: (<Copy text={copyIframe(item)} />),
              // actions: (<div className='cursor-pointer 'onClick={() => navigate(`/ib/promotionKit/${item?.id}`)} ><Eye /></div>),
              createdDate: item?.createdDate ? moment(item?.createdDate).format('DD-MM-YYYY, hh:mm A') : null,
            };
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  }

  const copyIframe = (item) => {
    return `<a href="https://client2.upforex.live/?tab=register&ref=${userDetails.referralCode}">
        <iframe src="http://localhost:3001/promotionKit/${item?.id}?ref=${userDetails.referralCode}" width="${item.width}" height="${item.height}" style="border:none;"></iframe>
    </a>`
  }

  useEffect(() => {
    getAllpromotion();
  }, [page, pageSize, searchText]);



  return (
    <div>
      {/* <div className="flex justify-between item-center flex-wrap gap-5">
        <div className="flex items-center flex-wrap gap-4">
          <Input
            size="large"
            style={{ width: 220 }}
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onPressEnter={() => setSearchText(search)}
            prefix={
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                <path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clip-rule="evenodd" />
              </svg>
            }
            suffix={search &&
              <svg xmlns="http://www.w3.org/2000/svg" onClick={() => { setSearchText(''); setSearch('') }} viewBox="0 0 24 24" fill="#bebebe" className="size-5 cursor-pointer duration-300 hover:fill-[#969595]">
                <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clip-rule="evenodd" />
              </svg>
            }
          />
         
        </div>
      </div> */}

      <div className="border border-gray-200 rounded-xl">
        <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
      </div>
      <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
    </div>
  );
}
